<template>
  <div container class="broker-of-record ">
    <h2 class="grape text-captialize _pl0">{{ cloudCannonContent.title }}</h2>
    <cloud-cannon-content
      class="_p0 transparent grape"
      :content-loading="cloudCannonContentLoading"
      :content="cloudCannonContent.header_summary"
    />
    <cloud-cannon-content class="_p0 transparent grape"
                          :content-loading="cloudCannonContentLoading"
                          :content="cloudCannonContent.form_explain"
    />
    <form @submit.prevent="submitBrokerOfRecord" method="POST">
      <div  class="bor-input-panel mt-4">
        <!-- Client Name / Agency Info -->
        <div class="info-box flex-column" grid="row wrap" >

          <div class="flex-row" >
            <div column="xs-12 m-8">
              <app-input
                label="Client Name:"
                v-model="$v.bor.clientName.$model"
                :error-message="clientNameError"
                :invalid="$v.bor.clientName.$invalid"
                :required="true"
                modifier=""
              />
            </div>
            <div column="xs-12 m-4">
            <span class="flex-row">
              <label>Client Account State</label>
              <validation-message :required="true" :invalid="$v.bor.clientAccountState.$invalid" :errorMessage="clientAccountStateError"/>
            </span>
              <select class="form-input"
                      v-model="$v.bor.clientAccountState.$model" :error-message="clientAccountStateError"
                      :invalid="$v.bor.clientAccountState.$invalid" :required="true" label="Agency Type:" >
                <option v-for="option in statesListOptions" :value="option.value">{{ option.text }}</option>
              </select>
            </div>
          </div>
          <div class="flex-row" >
            <div column="xs-12 l-5">
              <date-input
                v-model="$v.bor.changeEffectiveDate.$model"
                :error-message="changeDateError"
                :invalid="$v.bor.changeEffectiveDate.$invalid"
                :required="true"
                label="Change Effective Date"
                format="MM/DD/YYYY"/>


            </div>

            <div column="xs-12 l-5">
              <date-input
                v-model="$v.bor.commissionEffectiveDate.$model"
                :error-message="commissionDateError"
                :invalid="$v.bor.commissionEffectiveDate.$invalid"
                :required="true"
                label="Commission Effective Date"
                format="MM/DD/YYYY"/>
            </div>
          </div>
        </div>

        <div class="info-box" grid="row wrap" >
          <div class="flex-column" column="xs-12 l-12">
          <span class="flex-column">
            <span class="flex-row">
              <label>Attachments:</label>
              <validation-message :required="true" :invalid="$v.attachments.$invalid || failedFiles.length > 0" :errorMessage="attachmentsError"/>
            </span>
            <vue-dropzone
              id="dropzone"
              :key="dropZoneKey"
              ref="myVueDropzone"
              tabindex="0"
              class="_mbm"
              :options="dropzoneOptions"
              :use-custom-slot="true"
              duplicate-check
              @keydown.stop.native.enter="manuallyOpenDropzone"
              @vdropzone-thumbnail="thumbnail"
              @vdropzone-files-added="checkFiles"
              @vdropzone-removed-file="checkFiles"
            >
              <p>
                {{ value.fileUploader.label }} <br /><strong>{{
                  value.fileUploader.validationMessage
                }}</strong>
              </p>
            </vue-dropzone>
          </span>
        </div>
        </div>
        <!-- Agency Location -->
        <div class=" info-box" grid="row wrap">
          <div column="xs-12 m-8 l-8">
            <app-input v-model="$v.bor.agencyName.$model" :error-message="agencyNameError"
                       :invalid="$v.bor.agencyName.$invalid" :required="true" label="Agency Name:"></app-input>
          </div>
          <div column="xs-12 m-4 l-4">
            <app-input v-model="$v.bor.agencyTaxId.$model" id="agencyTaxIdInput" label="Tax Id:" :error-message="taxIdError"
                       :invalid="$v.bor.agencyTaxId.$invalid" :required="true"></app-input>
          </div>
          <div column="xs-12 m-12 l-12">
            <app-input v-model="$v.bor.agencyAddress.$model" :error-message="agencyAddressError"
                       :invalid="$v.bor.agencyAddress.$invalid" :required="true" label="Agency Address:"></app-input>
          </div>
        </div>

        <!-- Agency Contact Information -->
        <div grid="row wrap" class="flex-column info-box" >
          <h4 class="color-black">Agency Contact Information</h4>
          <div grid="row wrap" class="mt-2">
            <div column="xs-12 m-4">
              <app-input
                label="Name:"
                v-model="$v.bor.agencyContactName.$model"
                :error-message="agencyContactNameError"
                :invalid="$v.bor.agencyContactName.$invalid"
                :required="true"
              />
            </div>
            <div column="xs-12 m-5">
              <app-input
                label="Email:"
                v-model="$v.bor.agencyContactEmail.$model"
                :error-message="agencyContactEmailError"
                :invalid="$v.bor.agencyContactEmail.$invalid"
                :required="true"
              />
            </div>
            <div column="xs-12 m-3">
              <app-input
                label="Phone:"
                v-model="$v.bor.agencyContactPhone.$model"
                :error-message="agencyContactPhoneError"
                :invalid="$v.bor.agencyContactPhone.$invalid"
                :required="true"
              />
            </div>
          </div>

        </div>

        <!-- Agent Contact Information -->
        <div grid="row wrap" class="flex-column info-box">

          <div grid="row wrap"  >
            <h3  class="color-black" column="xs-12 l-8">Associated Agency</h3>
            <div class="flex-column" column="xs-12 l-4">
            <span class="flex-row">
              <label>Is another agency involved?</label>
              <validation-message :required="true" :invalid="$v.bor.isAnotherAgencyInvolved.$invalid" :errorMessage="anotherAgencyError"/>
            </span>
              <select v-model=$v.bor.isAnotherAgencyInvolved.$model :required="true"
                      :error-message="anotherAgencyError"
                      :invalid="$v.bor.isAnotherAgencyInvolved.$invalid">
                <option v-for="option in yesNoOptions" :value="option.value">{{ option.text }}</option>
              </select>
            </div>
          </div>
          <div  v-if="$v.bor.isAnotherAgencyInvolved.$model === 'Y'" grid="row wrap">

            <div class="flex-column" column="xs-12 l-8">
              <cloud-cannon-content class="_p0 transparent grape"
                :content-loading="cloudCannonContentLoading"
                :content="cloudCannonContent.another_agency_explained"
              />
            </div>

            <div class="flex-column" column="xs-12 l-4">
              <app-input v-model="$v.bor.associatedAgencyTaxId.$model" id="associatedAgencyTaxIdInput" label="Associated Agency Tax Id:" :error-message="associatedTaxIdError"
                         :invalid="$v.bor.associatedAgencyTaxId.$invalid" :required="true"></app-input>
            </div>

            <div column="xs-12 m-12" class="flex-column mt-2" >
              <h4 class="color-black">Associated Agency Contact Information</h4>
              <div grid="row wrap">
                <div column="xs-12 m-4">
                  <app-input
                    label="Name:"
                    v-model="$v.bor.associatedAgencyContactName.$model"
                    :error-message="agentContactNameError"
                    :invalid="$v.bor.associatedAgencyContactName.$invalid"
                    :required="true"

                  />
                </div>
                <div column="xs-12 m-5">
                  <app-input
                    label="Email:"
                    v-model="$v.bor.associatedAgencyContactEmail.$model"
                    :error-message="agentContactEmailError"
                    :invalid="$v.bor.associatedAgencyContactEmail.$invalid"
                    :required="true"

                  />
                </div>
                <div column="xs-12 m-3">
                  <app-input
                    label="Phone:"
                    v-model="$v.bor.associatedAgencyContactPhone.$model"
                    :error-message="agentContactPhoneError"
                    :invalid="$v.bor.associatedAgencyContactPhone.$invalid"
                    :required="true"

                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div grid="row wrap" class="button-panel">
        <button type="cancel" class="grape white _mtxs --sm" @click="$router.go(-1)">Cancel</button>
        <async-button type="submit" class="grape _mtxs --sm" :disabled="isSubmitButtonDisabled()" :executing="submissionLoading">
          <template #buttonContent>
            <span>Submit Broker of Record</span>
          </template>
        </async-button>
      </div>
    </form>
  </div>
</template>
<script>
import { mapGetters } from 'vuex'
import formattable from '@mixins/formattable'
import dragdrop from '@mixins/dragdrop'
import fetchable from '@mixins/fetchable'
import cloudCannonable from '@mixins/CloudCannonable'
import AppPlaceholderInput from '@atoms/PlaceholderInput'
import AsyncLoader from '@molecules/AsyncLoader'
import tableSorter from '@mixins/tableSorter'
import AppAdvancedTable from '@organisms/AdvancedTable'
import ColumnPicker from '@molecules/ColumnPicker'
import DateInput from '@atoms/DateInput'
import Select from '@atoms/Select'
import AppInput from '@atoms/Input'
import ValidationMessage from '@atoms/ValidationMessage'
import AsyncButton from '@molecules/AsyncButton.vue'
import {addressFromAgency, currentOrFutureDate, phoneNumber, taxIdEinOrSsn} from '../../utils';
import { statesList } from '@js/us-states'
import vue2Dropzone from 'vue2-dropzone'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import * as associatedAgenciesActionTypes from "@store/modules/associatedAgencies/actionTypes";
import * as serviceDeskActionTypes from "@store/modules/serviceDesk/actionTypes";
import * as mayAccountActionTypes from "@store/modules/myAccount/actionTypes";
import {alphaNum, maxLength, minLength, numeric, email, required} from "vuelidate/lib/validators";
import * as actionTypes from "@store/modules/associatedAgencies/actionTypes";
import * as authActionTypes from "@store/modules/auth/actionTypes";

export default {
  name: 'BookOfRecord',
  mixins: [tableSorter, formattable, cloudCannonable, dragdrop, fetchable],
  components: {
    AppPlaceholderInput,
    FontAwesomeIcon,
    AsyncLoader,
    AppAdvancedTable,
    ColumnPicker,
    DateInput,
    AppInput,
    AsyncButton,
    Select,
    ValidationMessage,
    vueDropzone: vue2Dropzone,
  },
  data() {
    return {
      fetchers: [
        {
          action: 'cloudCannon/GET_CLOUD_CANNON_CONTENT',
          options: {
            cloudCannonResource: '/service-desk-broker-of-record.json',
          },
        },
      ],
      acceptedFileTypes:  "image/*, application/pdf, text/*, application/vnd.ms-excel, " +
        "application/vnd.openxmlformats-officedocument.wordprocessingml.document (.docx), application/xml, application/zip, " +
        "application/vnd.oasis.open­document.text",
      locationOptions: [{}],
      contactOptions: [{}],
      yesNoOptions: [
        { value: 'Y', text: 'Yes' },
        { value: 'N', text: 'No' }
      ],
      statesListOptions:[],
      bor: {
        clientName: '',
        clientAccountState: '',
        changeEffectiveDate: '',
        commissionEffectiveDate: '',
        agencyName: '',
        agencyTaxId: '',
        agencyAddress: '',
        agencyContactName: '',
        agencyContactEmail: '',
        agencyContactPhone: '',
        associatedAgencyTaxId: '',
        associatedAgencyContactName: '',
        associatedAgencyContactEmail: '',
        associatedAgencyContactPhone: '',
        isAnotherAgencyInvolved: '',
        // requestType: '',
      },
      attachments: '',
    }
  },
  methods: {
    async updateAttachments() {
      this.$v.attachments.$model =  await this.$refs.myVueDropzone.getAcceptedFiles()
    },
    getAssociatedContactList(){
      const opts = { accountId: this.$v.bor.agencyLocation.$model.accountId, onlyUsers: 'N' };
      this.$store.dispatch(associatedAgenciesActionTypes.GET_ASSOCIATED_CONTACT_LIST, opts)
        .then((result) => {
          const contactOptions = this.associatedAgencyContactList.map(contact => new Object({
            text: contact.contactId,
            value: contact
          }))
          // contactOptions.unshift({text: '', value: null})
          this.contactOptions = contactOptions
        })
    },

    isSubmitButtonDisabled(){
      if(this.failedFiles.length > 0){
        return true
      }
      if(this.$v.bor.isAnotherAgencyInvolved.$model === 'Y' && !this.$v.$invalid) {
        return false
      }
      if(this.$v.bor.isAnotherAgencyInvolved.$model === 'N' && (
          this.$v.bor.agencyName.$invalid
        || this.$v.bor.clientAccountState.$invalid
        || this.$v.bor.changeEffectiveDate.$invalid
        || this.$v.bor.commissionEffectiveDate.$invalid
        || this.$v.bor.agencyTaxId.$invalid
        || this.$v.bor.agencyAddress.$invalid
        || this.$v.bor.agencyContactName.$invalid
        || this.$v.bor.agencyContactEmail.$invalid
        || this.$v.bor.agencyContactPhone.$invalid
        || this.$v.attachments.$invalid
      )){
        return true
      } else if(this.$v.bor.isAnotherAgencyInvolved.$model === 'N' ) {
        return false
      }

      return true
    },
    async submitBrokerOfRecord(record){
      await this.updateAttachments()
      if(this.$v.bor.isAnotherAgencyInvolved.$model === 'N' ){
        this.$v.bor.associatedAgencyTaxId.$model = ''
        this.$v.bor.associatedAgencyContactName.$model = ''
        this.$v.bor.associatedAgencyContactEmail.$model = ''
        this.$v.bor.associatedAgencyContactPhone.$model = ''
      }
      const redirect = () => this.$router.go(-1)
      this.$store.dispatch(serviceDeskActionTypes.SUBMIT_BOR_REQUEST, { body: this.bor, attachments: this.attachments, redirect } )
    },
  },
  computed: {
    ...mapGetters(['associatedAgencyList', 'associatedAgencyListLoading',
      'associatedAgencyContactList', 'associatedAgencyContactListLoading',
      'brokerPersonalInfo',
      'brokerPersonalInfoLoading',
      'submissionLoading',
      'contactType', 'minimumAccess'
    ]),
    attachmentsError() {
      if(this.failedFiles.length > 0){
        return 'Remove failed upload(s)'
      } else if (!this.$v.attachments.required) {
        return 'Required'
      } else if (!this.$v.attachments.maxLength) {
        return '5 file max'
      }
      return null
    },
    clientNameError() {
      if (!this.$v.bor.clientName.required) {
        return 'required';
      } else if (!this.$v.bor.clientName.maxLength) {
        return '255 character max';
      }
      return null;
    },
    agencyContactNameError(){
      if (!this.$v.bor.agencyContactName.required) {
        return 'Required';
      } else if (!this.$v.bor.agencyContactName.maxLength) {
        return '80 character max';
      }
      return null;
    },
    agencyContactEmailError(){
      if (!this.$v.bor.agencyContactEmail.required) {
        return 'Required';
      } else if (!this.$v.bor.agencyContactEmail.email) {
        return 'invalid email';
      } else if (!this.$v.bor.agencyContactEmail.maxLength) {
        return '255 character max';
      }
      return null;
    },
    agencyContactPhoneError(){
      if (!this.$v.bor.agencyContactPhone.required) {
        return 'Required';
      } else if (!this.$v.bor.agencyContactPhone.phoneNumber) {
        return 'bad format';
      }
      return null;
    },
    agentContactNameError(){
      if (!this.$v.bor.associatedAgencyContactName.required) {
        return 'Required';
      } else if (!this.$v.bor.associatedAgencyContactName.maxLength) {
        return '80 character max';
      }
      return null;
    },
    agentContactEmailError(){
      if (!this.$v.bor.associatedAgencyContactEmail.required) {
        return 'Required';
      } else if (!this.$v.bor.associatedAgencyContactEmail.email) {
        return 'invalid email';
      } else if (!this.$v.bor.associatedAgencyContactEmail.maxLength) {
        return '255 character max';
      }
      return null;
    },
    agencyNameError(){
      if (!this.$v.bor.agencyName.required) {
        return 'Required';
      } else if (!this.$v.bor.agencyName.maxLength) {
        return '255 character max';
      }
      return null;
    },
    agencyAddressError(){
      if (!this.$v.bor.agencyAddress.required) {
        return 'Required';
      } else if (!this.$v.bor.agencyAddress.maxLength) {
        return '255 character max';
      }
      return null;
    },
    taxIdError(){
      if (!this.$v.bor.agencyTaxId.required) {
        return 'Required';
      } else if (!this.$v.bor.agencyTaxId.taxIdEinOrSsn) {
        return 'bad format';
      }
      return null;
    },
    associatedTaxIdError(){
      if (!this.$v.bor.associatedAgencyTaxId.required) {
        return 'Required';
      } else if (!this.$v.bor.associatedAgencyTaxId.taxIdEinOrSsn) {
        return 'bad format';
      }
      return null;
    },
    agentContactPhoneError(){
      if (!this.$v.bor.associatedAgencyContactPhone.required) {
        return 'Required';
      } else if (!this.$v.bor.associatedAgencyContactPhone.phoneNumber) {
        return 'bad format';
      }
      return null;
    },
    changeDateError() {
      if (!this.$v.bor.changeEffectiveDate.required) {
        return 'Required';
      } else if (!this.$v.bor.changeEffectiveDate.currentOrFutureDate){
        return '>= current date'
      }
      return null;
    },
    commissionDateError() {  //TODO
      if (!this.$v.bor.commissionEffectiveDate.required) {
        return 'Required';
      }
      else if (!this.$v.bor.commissionEffectiveDate.currentOrFutureDate){
        return '>= current date'
      }
      return null;
    },
    clientAccountStateError() {
      if (!this.$v.bor.clientAccountState.required) {
        return 'Required';
      }
    },
    anotherAgencyError() {
      if (!this.$v.bor.isAnotherAgencyInvolved.required) {
        return 'Required';
      }
    },
  },
  beforeMount(){
    if (this.contactType === 'WRITING_BROKER' ||this.contactType !== 'WRITING_BROKER' && !this.minimumAccess.commissionAllowed ) {
      const redirect = () => this.$router.go(-1)
      this.$store.dispatch(authActionTypes.SUBMIT_PAYMENT_INQUIRY_UNAUTHORIZED, { redirect } )
    }else {
      this.dropzoneCallback = this.updateAttachments
      for (const stateCode in statesList) {
        this.statesListOptions.push({text: statesList[stateCode], value: stateCode})
      }

      if(!this.brokerPersonalInfo.contactName){
        this.$store.dispatch(mayAccountActionTypes.GET_BROKER_PERSONAL_INFO)
          .then((result) => {
            this.$v.bor.agencyContactName.$model = this.brokerPersonalInfo.contactName
            this.$v.bor.agencyContactEmail.$model = this.brokerPersonalInfo.email
            this.$v.bor.agencyContactPhone.$model = this.brokerPersonalInfo.workPhone
          })
      } else{
        this.$v.bor.agencyContactName.$model = this.brokerPersonalInfo.contactName
        this.$v.bor.agencyContactEmail.$model = this.brokerPersonalInfo.email
        this.$v.bor.agencyContactPhone.$model = this.brokerPersonalInfo.workPhone
      }
    }
  },

  validations: {
    attachments: {
      required,
      maxLength: maxLength(5),
    },
    bor: {
      required,
      clientName: {
        required,
        minLength: minLength(1),
        maxLength: maxLength(255),
      },
      clientAccountState: {
        required,
        minLength: minLength(1)
      },
      changeEffectiveDate: {
        required,
        currentOrFutureDate,
      },
      commissionEffectiveDate: {
        required,
        currentOrFutureDate,
      },
      agencyTaxId: {
        required,
        taxIdEinOrSsn,
      },
      agencyAddress: {
        required,
        maxLength: maxLength(255)
      },
      agencyName: {
        required,
        maxLength: maxLength(255)
      },
      agencyContactName: {
        required,
        maxLength: maxLength(80),
      },
      agencyContactEmail: {
        required,
        email,
        maxLength: maxLength(255),
      },
      agencyContactPhone: {
        required,
        phoneNumber,
      },
      isAnotherAgencyInvolved: {
        required,
      },
      associatedAgencyTaxId: {
        required,
        taxIdEinOrSsn,
      },
      associatedAgencyContactName: {
        required,
        maxLength: maxLength(80),
      },
      associatedAgencyContactEmail: {
        required,
        email,
        maxLength: maxLength(255),
      },
      associatedAgencyContactPhone: {
        required,
        phoneNumber,
      },
    },
  },
}
</script>
<style lang="scss" scoped>
.all-clients {
  .text-captialize {
    font-size: 1.75rem;
    line-height: 1;
    color: #2b2c2e;
    text-transform: capitalize;
  }
}
span.validation {
  display: flex;
  align-items: center;
  margin-left: .3em;
}
</style>
